var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper",
      staticStyle: {
        "min-width": "1000px",
        width: "100%",
        height: "100%",
        "max-height": "100%",
        overflow: "auto"
      },
      attrs: { id: "share_transfer" }
    },
    [
      _c("div", { attrs: { id: "leftBan" } }),
      _vm._v(" "),
      _c("div", { staticClass: "sf-logo" }, [
        _c("div", { staticClass: "logo-transfer" }),
        _c("div", {
          domProps: {
            innerHTML: _vm._s(_vm.$t("language.shareTransfers.logoMsg"))
          }
        })
      ]),
      _vm._v(" "),
      _c("rightContBan", { ref: "rightContBan" }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.initLoading,
              expression: "initLoading"
            }
          ],
          staticClass: "share_page_boby all-loadPage"
        },
        [
          _c("div", { staticClass: "img-loading" }, [
            _c("img", {
              attrs: { src: require("../assets/images/loading.gif") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "load-size" }, [
              _c("b", [
                _vm._v(_vm._s(_vm.$t("language.common.load"))),
                _c("span", { staticClass: "dotting" })
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "share-transfer-buttom center",
          attrs: { id: "share_transfer_body" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading"
                }
              ],
              attrs: { id: "check_share" }
            },
            [
              _c("div", { staticClass: "share-transfer-body" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectItemArr.length > 0 &&
                          _vm.shareTransferState == "check",
                        expression:
                          "selectItemArr.length>0&&shareTransferState=='check'"
                      }
                    ],
                    staticClass: "share-transfer-items",
                    attrs: { id: "sfFilesItems" }
                  },
                  [
                    _c(
                      "el-scrollbar",
                      { ref: "scrollbar", staticStyle: { height: "100%" } },
                      [
                        _c(
                          "div",
                          { staticClass: "share-transfer-files" },
                          _vm._l(_vm.selectItemArr, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "share-transfer-item file-item"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "share-title",
                                    attrs: { title: item.name }
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _vm._v(" "),
                                item.size
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm._f("formatByte")(item.size))
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.shareTransfers.folder"
                                          )
                                        )
                                      )
                                    ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "icon-close",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteSelectFiles(
                                        index,
                                        item.keyId
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "share-transfer-options",
                            class: _vm.selectItemArr.length < 4 ? "bottom" : ""
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "share-transfer-item add-transfer-item",
                                on: {
                                  click: function($event) {
                                    return _vm.transferSourceDialogShow()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "icon-add-hover" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "icon-add" }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.shareTransfers.addFiles"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.shareTransfers.addFileTip",
                                          { num: this.selectItemArr.length }
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "share-transfer-item share-transfer-option",
                                on: {
                                  click: function($event) {
                                    return _vm.checkOption("shareTitle")
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: _vm.checkTitle
                                      ? "font-size:12px;"
                                      : ""
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.shareTransfers.transferTitle"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.transferInfoTitle,
                                        expression: "transferInfoTitle"
                                      }
                                    ],
                                    staticClass: "name-edit-input",
                                    attrs: {
                                      type: "text",
                                      name: "title",
                                      id: "shareTitle",
                                      autocomplete: "Off",
                                      maxLength: 129
                                    },
                                    domProps: { value: _vm.transferInfoTitle },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.transferInfoTitle =
                                            $event.target.value
                                        },
                                        function($event) {
                                          return _vm.writeTextCheck("title")
                                        }
                                      ],
                                      focus: function($event) {
                                        _vm.checkTitle = true
                                      },
                                      blur: function($event) {
                                        _vm.checkTitle = false
                                      }
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("hr", {
                              attrs: { color: "#eff5fd", size: "1" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "share-transfer-item share-transfer-option",
                                on: {
                                  click: function($event) {
                                    return _vm.checkOption("shareDescription")
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: _vm.checkDes ? "font-size:12px;" : ""
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.shareTransfers.transferDescription"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.transferInfoDescription,
                                        expression: "transferInfoDescription"
                                      }
                                    ],
                                    ref: "shareDescription",
                                    attrs: {
                                      rows: "1",
                                      type: "text",
                                      name: "description",
                                      id: "shareDescription",
                                      autocomplete: "Off",
                                      maxLength: 513,
                                      onkeydown:
                                        "if(event.keyCode==13)return false;"
                                    },
                                    domProps: {
                                      value: _vm.transferInfoDescription
                                    },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.transferInfoDescription =
                                            $event.target.value
                                        },
                                        function($event) {
                                          return _vm.writeTextCheck(
                                            "description"
                                          )
                                        }
                                      ],
                                      focus: function($event) {
                                        _vm.checkDes = true
                                      },
                                      blur: function($event) {
                                        _vm.checkDes = false
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selectItemArr.length == 0 &&
                _vm.shareTransferState == "check"
                  ? _c(
                      "div",
                      {
                        staticClass: "share-transfer-items center",
                        attrs: { id: "sfAddItems" },
                        on: {
                          click: function($event) {
                            return _vm.transferSourceDialogShow()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "share-transfer-add" }, [
                          _c("div", { staticClass: "icon-add-hover" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-add" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.shareTransfers.addFiles"))
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shareTransferState == "transfering" ||
                _vm.shareTransferState == "canceling"
                  ? _c(
                      "div",
                      {
                        staticClass: "share-transfer-items center",
                        attrs: { id: "sfProgressBar" }
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: { width: "200px", height: "200px" }
                            },
                            [
                              _c("svg-line", {
                                attrs: {
                                  rate: _vm.progressNum,
                                  "bg-ring-color": "#EBEBEC",
                                  "stroke-width": 24,
                                  part: 1,
                                  "part-gap": 0,
                                  "show-gradient": true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.shareTransferState == "transfering"
                            ? _c("div", { staticClass: "sf-transfer-msgs" }, [
                                _c("div", { staticClass: "sf-transfer-msg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.shareTransfers.trnsfering"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sf-transfer-num" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.shareTransfers.sendingFile",
                                        { num: this.selectItemArr.length }
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sf-transfer-size" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.shareTransfers.sendingTip"
                                      )
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.shareTransferState == "canceling"
                            ? _c("div", { staticClass: "sf-transfer-msgs" }, [
                                _c("div", { staticClass: "sf-transfer-msg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.shareTransfers.cancelTransfer"
                                      )
                                    )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shareTransferState == "existence"
                  ? _c(
                      "div",
                      {
                        staticClass: "share-transfer-items center",
                        attrs: { id: "sfExistence" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "share-back center",
                            on: {
                              click: function($event) {
                                return _vm.backNewTransfer()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass: "icon-util arrow-left-blue"
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.cloudExploer.back"))
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", { attrs: { src: _vm.GIF } }),
                          _vm._v(" "),
                          _c("div", { staticClass: "sf-transfer-msgs" }, [
                            _c("div", { staticClass: "sf-transfer-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.shareTransfers.createdTransfer"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "share-transfer-fun center",
                    attrs: { id: "share_buttons" }
                  },
                  [
                    _vm.shareTransferState == "check"
                      ? _c("div", { staticClass: "st-btn-other center" }, [
                          _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.createShareTransfer()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.shareTransfers.createShare")
                                )
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shareTransferState == "transfering"
                      ? _c("div", { staticClass: "st-btn-other center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "white-btn",
                              on: {
                                click: function($event) {
                                  _vm.shareTransferState = "canceling"
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shareTransferState == "canceling"
                      ? _c("div", { staticClass: "st-btn-other center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "white-btn",
                              on: {
                                click: function($event) {
                                  return _vm.cancelTransfer()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.yes")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.shareTransferState = "transfering"
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.no")))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shareTransferState == "existence"
                      ? _c("div", { staticClass: "st-btn-other center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "white-btn",
                              on: {
                                click: function($event) {
                                  return _vm.copySite()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.copyLink")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.shareDialgOpen()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.cloudExploerPopup.shareSendEmail"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "options-err-info",
                    class: _vm.isTitleErr ? "" : "fadeErr",
                    attrs: { id: "share_title_err" }
                  },
                  [
                    _c("div", { staticClass: "options-err-body center" }, [
                      _c("div", { staticClass: "icon-mistake" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("language.shareTransfers.titleErrMsg"))
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "options-err-info",
                    class: _vm.isDesErr ? "" : "fadeErr",
                    attrs: { id: "share_des_err" }
                  },
                  [
                    _c("div", { staticClass: "options-err-body center" }, [
                      _c("div", { staticClass: "icon-mistake" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("language.shareTransfers.desErrMsg"))
                        )
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("shareDialog", { ref: "shareDialog", attrs: { isTransfer: true } }),
      _vm._v(" "),
      _c("transferSourceDialog", { ref: "transferSourceDialog" }),
      _vm._v(" "),
      _c("signInDialog", { ref: "signInDialog", attrs: { isTransfer: true } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9c88e4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9c88e4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share_transfer.vue
// module id = null
// module chunks = 